<template>
  <div id="contenedor-contrato-agregar-avance-real">
    <v-form
      v-model="formularioValido"
      ref="registrarNuevoContratoAvanceReal">
      <template
        v-if="!esListado">
        <v-card>
          <v-card-title>
            Agregar avance real
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <custom-text-field
                  v-model.number="avanceReal.cantidad"
                  type="number"
                  @change="calcularImporte">
                </custom-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3">
            </custom-button>
            <custom-button
              @click="mixAgregarContratoAvanceReal"
              :disabled="!formularioValido || enviandoFormulario"
              :loading="enviandoFormulario"
              tipo="formAceptar"
              label="Guardar">
            </custom-button>
          </v-card-actions>
        </v-card>
      </template>
      <template
        v-else>
        <v-row
          no-gutters
          align="center">
          <v-col
            cols="9">
            <custom-text-field
              v-model.number="avanceReal.cantidad"
              @change="calcularImporte"
              es-dinero
              label="Parcial">
            </custom-text-field>
          </v-col>
          <v-col
            cols="auto">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="mixAgregarContratoAvanceReal"
                  icon
                  v-bind="attrs"
                  v-on="on"
                  color="#1B1BAF"
                  class="ml-1">
                  <v-icon>fa-save</v-icon>
                </v-btn>
              </template>
              <span>Guardar</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
    </v-form>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixContratoAvanceReal from './mixContratoAvanceReal';

export default {
  name: 'ContratoAgregarAvanceReal',
  mixins: [mixContratoAvanceReal],
  components: {
    CustomTextField,
    CustomButton,
  },
  props: {
    esListado: {
      type: Boolean,
      required: false,
      default: false,
    },
    idContrato: {
      type: String,
      required: true,
    },
    concepto: {
      type: Object,
      required: true,
    },
    cantidad: {
      type: Number,
      required: false,
      default: 0,
    },
    fecha: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      avanceReal: {
        idContrato: this.idContrato,
        idConcepto: this.concepto.idConcepto,
        cantidad: this.cantidad,
        importe: 0,
        fecha: this.fecha,
      },
    };
  },
  methods: {
    calcularImporte() {
      this.avanceReal.importe = (this.avanceReal.cantidad * this.concepto.concepto.precioUnitario);
    },
  },
  watch: {
    fecha: {
      handler(fecha) {
        this.avanceReal.fecha = fecha;
      },
    },
    cantidad: {
      handler(cantidad) {
        this.avanceReal.cantidad = cantidad;
      },
    },
  },
};
</script>

<style lang="scss">

</style>
